import React from 'react';

const HelpPage = () => (
  <p>Help</p>
);

export default HelpPage;
